<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-title w-100 p-2 mb-0">
          <div class="row justify-content-between align-items-center">
            <div class="col-xl-3 col-12 mb-md-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>

            <div class="col-xl-9 col-12 text-right">
              <label for="monthYear" class="mb-0 mr-1" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
                <select [(ngModel)]="selectedMonth" (ngModelChange)="loadCollaborators()" id="monthYear" class="form-control pr-3 text-capitalize">
                  <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                  <option *ngFor="let month of availableMonths" [value]="month" [label]="formatLabel(month)">{{ month }}</option>
                </select>
              </label>
              <label for="years" class="mb-0 mr-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
                <select id="years" [(ngModel)]="selectedYear" (change)="loadCollaborators()" class="form-control pr-3">
                  <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                </select>
              </label>
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <label for="page_quantity" class="d-flex align-items-center"
                  >{{ "SHOW" | translate }}
                  <select id="page_quantity" class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 150"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterCollaboratorList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [sorts]="[{ prop: 'complete_name', dir: 'asc' }]"
          >
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="_utilService.isDesktop" [width]="auto">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <a routerLink="/dashboard/collaborators/edit/{{ row.hash }}">{{ row.complete_name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TITLES.USERS_TYPES_SINGULAR.external' | translate" prop="provider_name" *ngIf="_utilService.isDesktop" [width]="auto">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <a routerLink="/dashboard/provider/{{ row.provider_id }}" *ngIf="row.provider_id">{{ row.provider_name }}</a>
                  <span *ngIf="!row.provider_id">-</span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PRESUMED_TOTAL_MONTHLY_COST' | translate" prop="estimate_monthly_cost" *ngIf="_utilService.isDesktop" [width]="auto">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="ml-025">{{ _utilService.addDotsToNumber(row.estimate_monthly_cost) }} €</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EFFECTIVE_TOTAL_MONTHLY_COST' | translate" prop="monthly_cost" *ngIf="_utilService.isDesktop" [width]="auto">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <span *ngIf="!row.editCost" class="ml-025">{{ _utilService.addDotsToNumber(row.monthly_cost) }} €</span>
                  <input
                    *ngIf="row.editCost"
                    (change)="formatPrice(row)"
                    [(ngModel)]="row.new_monthly_cost"
                    name="monthly_cost"
                    type="text"
                    [id]="'monthly_cost_' + i"
                    class="form-control"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <button
                    class="bg-transparent border-0 text-primary mb-025"
                    (click)="openEdit(row)"
                    [ngbTooltip]="'EDIT' | translate"
                    *ngIf="_authenticationService.hasCapability('manage_collaborators_costs') && !row.editCost"
                  >
                    <span [data-feather]="'edit-2'" size="16"></span>
                  </button>
                  <button
                    class="bg-transparent border-0 text-warning"
                    (click)="cancelEdit(row)"
                    [ngbTooltip]="'CANCEL' | translate"
                    *ngIf="_authenticationService.hasCapability('manage_collaborators_costs') && row.editCost"
                  >
                    <span [data-feather]="'x'" size="16" class="mr-50"></span>
                  </button>
                  <button
                    class="bg-transparent border-0 text-success"
                    (click)="updateCost(row)"
                    [ngbTooltip]="'SAVE' | translate"
                    *ngIf="_authenticationService.hasCapability('manage_collaborators_costs') && row.editCost"
                  >
                    <span [data-feather]="'check'" size="16"></span>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!-- mobile - tablet -->
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <a routerLink="/dashboard/collaborators/edit/{{ row.hash }}">{{ row.complete_name }}</a>
                  </div>

                  <div class="col-12">
                    <span
                      >{{ "TITLES.USERS_TYPES_SINGULAR.external" | translate }}: <a routerLink="/dashboard/provider/{{ row.provider_id }}" *ngIf="row.provider_id">{{ row.provider_name }}</a>
                      <span *ngIf="!row.provider_id">-</span>
                    </span>
                  </div>
                  <div class="col-12">
                    <span>{{ "PRESUMED_TOTAL_MONTHLY_COST" | translate }}: {{ _utilService.addDotsToNumber(row.estimate_monthly_cost) }} €</span>
                  </div>
                  <div class="col-12 d-flex align-items-center">
                    <span>{{ "EFFECTIVE_TOTAL_MONTHLY_COST" | translate }}: </span>
                    <span *ngIf="!row.editCost">{{ _utilService.addDotsToNumber(row.monthly_cost) }} €</span>
                    <input
                      *ngIf="row.editCost"
                      (change)="formatPrice(i)"
                      [(ngModel)]="row.new_monthly_cost"
                      name="monthly_cost"
                      type="text"
                      [id]="'monthly_cost_' + i"
                      class="form-control"
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <button
                      class="bg-transparent border-0 text-primary mb-025"
                      (click)="openEdit(row)"
                      [ngbTooltip]="'EDIT' | translate"
                      *ngIf="_authenticationService.hasCapability('manage_collaborators_costs') && !row.editCost"
                    >
                      <span [data-feather]="'edit-2'" size="16"></span>
                    </button>
                    <button
                      class="bg-transparent border-0 text-warning"
                      (click)="cancelEdit(row)"
                      [ngbTooltip]="'CANCEL' | translate"
                      *ngIf="_authenticationService.hasCapability('manage_collaborators_costs') && row.editCost"
                    >
                      <span [data-feather]="'x'" size="16"></span>
                    </button>
                    <button
                      class="bg-transparent border-0 text-success"
                      (click)="updateCost(row)"
                      [ngbTooltip]="'SAVE' | translate"
                      *ngIf="_authenticationService.hasCapability('manage_collaborators_costs') && row.editCost"
                    >
                      <span [data-feather]="'check'" size="16"></span>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
